import * as yup from 'yup';
import { string } from 'yup';
import Regex from 'constants/regex';
import Validation from 'constants/validation-messages';

export const RENEWAL_OPTIONS = [
  { label: 'No Restrictions', value: 'No Restrictions' },
  { label: 'No Reissue After Expiry', value: 'No Reissue After Expiry' },
  {
    label: 'No Replacement or Reissue Allowed',
    value: 'No Replacement or Reissue Allowed',
  },
];

export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_FORMAT_HYPHEN = 'YYYY-MM-DD';
export const DATE_FORMATS = [
  'DD/MM/YYYY',
  'DD/M/YYYY',
  'D/M/YYYY',
  'D/MM/YYYY',
  'DD/MM/YY',
];

export const addressValidationSchema = yup.object().shape({
  addressLine1: string()
    .nullable()
    .transform((value) => (value ? value.trim() : value))
    .max(40, Validation.MAX_CHAR_FORTY)
    .optional(),
  addressLine2: string()
    .nullable()
    .transform((value) => (value ? value.trim() : value))
    .required(Validation.ADDRESS_LINE_2_REQUIRED)
    .max(40, Validation.MAX_CHAR_FORTY),
  city: string()
    .nullable()
    .transform((value) => (value ? value.trim() : value))
    .required(Validation.CITY_REQUIRED)
    .max(30, Validation.MAX_CHAR_THIRTY),
  state: yup.string().nullable().required(Validation.STATE_REQUIRED),
  postcode: string()
    .nullable()
    .required(Validation.POSTCODE_REQUIRED)
    .matches(Regex.POSTCODE, {
      excludeEmptyString: true,
      message: Validation.POSTCODE,
    }),
});

export const AUSSIE_STATES = [
  { label: 'NSW', value: 'NSW' },
  { label: 'ACT', value: 'ACT' },
  { label: 'SA', value: 'SA' },
  { label: 'VIC', value: 'VIC' },
  { label: 'QLD', value: 'QLD' },
  { label: 'NT', value: 'NT' },
  { label: 'WA', value: 'WA' },
  { label: 'TAS', value: 'TAS' },
];

export const addressTypeTitle = {
  MR_ADDR: 'Merchant report (MR) address',
  EC_ADDR: 'EC transaction file address',
  NB_ADDR: 'NB transaction file address',
  NP_ADDR: 'NP transaction file address',
  NS_ADDR: 'NS transaction file address',
  TE_ADDR: 'TE transaction file address',
  OWS_PS: 'Address for payment scheme',
  PST_ADDR: 'Postal address',
  CRD_ML_ADDR: 'Card mailing address',
  PHS_ADDR: 'Physical address',
  STMT_ADDR: 'Statement (CS or SI) address',
  AI_ADDR: 'AmpolCard invoice (AI) address',
  IR_ADDR: 'Periodic rebate invoice (IR) address',
  CI_ADDR: 'AmpolCash invoice (CI) address',
  SC_ADDR: 'AmpolCash load RCTI (SC) address',
  DIR1_ADDR: 'Director 1 address',
  DIR2_ADDR: 'Director 2 address',
  DIR3_ADDR: 'Director 3 address',
  DIR4_ADDR: 'Director 4 address',
  DIR5_ADDR: 'Director 5 address',
  DIR6_ADDR: 'Director 6 address',
  DIR7_ADDR: 'Director 7 address',
  DIR8_ADDR: 'Director 8 address',
  MS_ADDR: 'Merchant statement (MS) address',
  M_ADDR: 'Marketing address',
  OPER_ADDR: 'Operator contact address',
  LOC_ADDR: 'Location contact address',
  NET_NOTIF_ADDR: 'Network notifications address',
  SF_ADDR: 'Merchant service Fee (SF) address',
};

export const salutations = [
  { label: 'MR', value: 'MR' },
  { label: 'MRS', value: 'MRS' },
  { label: 'DR', value: 'DR' },
  { label: 'MISS', value: 'MISS' },
  { label: 'MS', value: 'MS' },
  { label: 'ACCOUNTS', value: 'ACCOUNTS' },
  { label: 'ADMIN OFFICER', value: 'ADMIN_OFFICER' },
  { label: 'DIRECTOR', value: 'DIRECTOR' },
  { label: 'FLEET OFFICER', value: 'FLEET_OFFICER' },
  { label: 'MANAGER', value: 'MANAGER' },
  { label: 'PROFESSOR', value: 'PROF' },
  { label: 'FATHER', value: 'FR' },
  { label: 'SENIOR', value: 'SR' },
];

export const roadSideAssistType = {
  PassengerKey: 'Passenger',
  Passenger: 'Passenger GVM < 3.5t',
  HeavyVehicles: 'Heavy GVM > 12t',
  TruckKey: 'Trucks',
  Truck: 'Truck GVM 3.5 - 12t',
};

export const roadSideAssistTypeCode = {
  P: 'Passenger',
  PC: 'Passenger',
  H: 'HeavyVehicles',
  HC: 'HeavyVehicles',
  T: 'Truck',
  TC: 'Truck',
};

export const CashShippingMethods = {
  1: 'Direct to Customer',
  4: 'Standard post',
  7: 'Express post',
  10: 'Courier',
  17: 'Return to Head Office',
  18: 'Virtual AmpolCash',
};

export const cashOrderStatuses = [
  {
    label: 'All',
    value: null,
  },
  {
    label: 'Active',
    value: 'Active',
  },
  {
    label: 'Processing',
    value: 'Processing',
  },
  {
    label: 'Closed',
    value: 'Closed',
  },
];

export const VERIFICATION_METHODS = [
  { label: 'None', value: 'None' },
  { label: 'PIN', value: 'PIN' },
  { label: 'Signature', value: 'Signature' },
  { label: 'Mandatory PIN', value: 'Mandatory PIN' },
];
